module.exports = __webpack_public_path__ + "static/media/motic wireframe1.1564ae3a.png";